import * as fromDatatype from '../datatype-library/index';

export interface bl_alg_cc_outbound_task_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  agent_guid: fromDatatype.GuidDataFieldInterface;
  login_subject_guid: fromDatatype.GuidDataFieldInterface;
  description: fromDatatype.VarcharDatatypeInterface;
  priority: fromDatatype.IntegerDatatypeInterface;
  target_type: fromDatatype.VarcharDatatypeInterface;
  target_guid: fromDatatype.GuidDataFieldInterface;
  target_property_json: fromDatatype.JsonDatatypeInterface;
  source_type: fromDatatype.VarcharDatatypeInterface;
  source_guid: fromDatatype.GuidDataFieldInterface;
  source_property_json: fromDatatype.JsonDatatypeInterface;
  task_status: fromDatatype.VarcharDatatypeInterface;
  task_category: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
}

export class bl_alg_cc_outbound_task_hdr_RowClass implements bl_alg_cc_outbound_task_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  agent_guid: fromDatatype.GuidDataFieldInterface;
  login_subject_guid: fromDatatype.GuidDataFieldInterface;
  description: fromDatatype.VarcharDatatypeInterface;
  priority: fromDatatype.IntegerDatatypeInterface;
  target_type: fromDatatype.VarcharDatatypeInterface;
  target_guid: fromDatatype.GuidDataFieldInterface;
  target_property_json: fromDatatype.JsonDatatypeInterface;
  source_type: fromDatatype.VarcharDatatypeInterface;
  source_guid: fromDatatype.GuidDataFieldInterface;
  source_property_json: fromDatatype.JsonDatatypeInterface;
  task_status: fromDatatype.VarcharDatatypeInterface;
  task_category: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
}
